import { useAccess } from "../bridges/frame";
import { useAccess as useNextAccess } from "../access/api";
import { useAccountLocked } from "../bridges/locked";

/**
 * Who sees the bell (walkthrough M3): today's `read_notifications`, or anyone the access model answers for. New-model Team
 * members hold no `read_notifications`, yet they receive their own updates (answers to their reports, a route given to them,
 * reminders) and the server's inbox answers everyone signed in; Notice choices already offer them "In the bell".
 */
export const useCanSeeNotifications = (): boolean => {
  const legacy = useAccess().has("read_notifications");
  const next = useNextAccess();
  // A locked account answers 402 to the bell's counts on every page: no bell, no calls.
  const locked = useAccountLocked();
  return !locked && (legacy || (!!next.data && !next.error));
};
